export default "__VITE_ASSET__DVVb$PnW__"